import React from 'react'
import { render } from 'react-dom'
import SettingsTemplate from './Settings'

export default React.createClass({
    // settingComponent tells us which compoent to activiate within the settings page
    render(){
        return (
            <div class="row">
                <SettingsTemplate settingComponent={this.props.route.settingComponent} />
            </div>
        )
    }
});


// WEBPACK FOOTER //
// app/views/Settings/index.js